var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.embedShow,
          expression: "embedShow"
        }
      ],
      staticClass: "h-vertical-align-container"
    },
    [
      _c("div", {
        staticClass: "embed-popup__overlay fadeIn",
        on: {
          click: function($event) {
            _vm.close()
          }
        }
      }),
      _c("div", { staticClass: "modal__wrapper" }, [
        _c("div", { staticClass: "embed-popup fadeInDown" }, [
          _c("div", { staticClass: "embed__popup--container" }, [
            _c("div", {
              staticClass: "modal__close embed__close",
              on: {
                click: function($event) {
                  _vm.close()
                }
              }
            }),
            _vm.isCopied
              ? _c(
                  "span",
                  { staticClass: "ready fadeInDownEmbed embed_copy" },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "https://cdn.flixel.com/static/static-web/misc/embed_copy.png"
                      }
                    })
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "embed__popup--item embed--radio" }, [
              _c("div", { staticClass: "ui-input ui-input--radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sizing,
                      expression: "sizing"
                    }
                  ],
                  attrs: { type: "radio", value: "responsive" },
                  domProps: { checked: _vm._q(_vm.sizing, "responsive") },
                  on: {
                    change: function($event) {
                      _vm.sizing = "responsive"
                    }
                  }
                }),
                _c("label", [_vm._v("Responsive")])
              ]),
              _c("div", { staticClass: "ui-input ui-input--radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sizing,
                      expression: "sizing"
                    }
                  ],
                  attrs: { type: "radio", value: "fixed" },
                  domProps: { checked: _vm._q(_vm.sizing, "fixed") },
                  on: {
                    change: function($event) {
                      _vm.sizing = "fixed"
                    }
                  }
                }),
                _c("label", [_vm._v("Fixed")])
              ])
            ]),
            _c("div", { staticClass: "embed__popup--item" }, [
              _vm.sizing === "fixed"
                ? _c("div", { staticClass: "ui-input" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.customSize.type,
                            expression: "customSize.type"
                          }
                        ],
                        attrs: { name: "sizeSelector" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.customSize,
                                "type",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            _vm.updateCustom
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { value: "custom" } }, [
                          _vm._v("Custom Size")
                        ]),
                        _c("option", { attrs: { value: "small" } }, [
                          _vm._v(
                            _vm._s(_vm.resizer.small.width) +
                              " X " +
                              _vm._s(_vm.resizer.small.height)
                          )
                        ]),
                        _c("option", { attrs: { value: "medium" } }, [
                          _vm._v(
                            _vm._s(_vm.resizer.medium.width) +
                              " X " +
                              _vm._s(_vm.resizer.medium.height)
                          )
                        ]),
                        _c("option", { attrs: { value: "large" } }, [
                          _vm._v(
                            _vm._s(_vm.resizer.large.width) +
                              " X " +
                              _vm._s(_vm.resizer.large.height)
                          )
                        ])
                      ]
                    ),
                    _vm.customSize.type === "custom"
                      ? _c("div", { staticClass: "custom-size-embed" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.customSize.width,
                                expression: "customSize.width"
                              }
                            ],
                            staticClass: "small-input-hack",
                            attrs: { type: "text" },
                            domProps: { value: _vm.customSize.width },
                            on: {
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.customSize,
                                    "width",
                                    $event.target.value
                                  )
                                },
                                function($event) {
                                  _vm.changeWidth(_vm.customSize.width)
                                }
                              ]
                            }
                          }),
                          _c("span", { staticClass: "custom-size-x" }, [
                            _vm._v("x")
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.customSize.height,
                                expression: "customSize.height"
                              }
                            ],
                            staticClass: "small-input-hack",
                            attrs: { type: "text" },
                            domProps: { value: _vm.customSize.height },
                            on: {
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.customSize,
                                    "height",
                                    $event.target.value
                                  )
                                },
                                function($event) {
                                  _vm.changeHeight(_vm.customSize.height)
                                }
                              ]
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _c("div", { staticClass: "embed__popup--item" }, [
              _c("div", { staticClass: "ui-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.queryParams.useHd,
                      expression: "queryParams.useHd"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.queryParams.useHd)
                      ? _vm._i(_vm.queryParams.useHd, null) > -1
                      : _vm.queryParams.useHd
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.queryParams.useHd,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.queryParams,
                              "useHd",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.queryParams,
                              "useHd",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.queryParams, "useHd", $$c)
                      }
                    }
                  }
                }),
                _c("label", [_vm._v("Use HD")])
              ])
            ]),
            _vm._m(0),
            _c(
              "div",
              { staticClass: "embed__popup--item embed__popup--embedCode" },
              [
                _c("p", [_vm._v("Embed Code")]),
                _c(
                  "div",
                  {
                    staticClass: "ui-input",
                    on: {
                      click: function($event) {
                        _vm.clickTextArea()
                      }
                    }
                  },
                  [
                    _vm.sizing !== "responsive"
                      ? _c(
                          "textarea",
                          {
                            staticClass: "embed_url",
                            attrs: {
                              type: "text",
                              readonly: "readonly",
                              resize: "none",
                              wrap: "off",
                              value: ""
                            }
                          },
                          [
                            _vm._v(
                              '<div class="flx-embed"><iframe width="' +
                                _vm._s(_vm.customSize.width) +
                                '" height="' +
                                _vm._s(_vm.customSize.height) +
                                '" src="' +
                                _vm._s(_vm.flixel.embed_url) +
                                "?hd=" +
                                _vm._s(_vm.queryParams.useHd) +
                                '" frameborder="0" allowfullscreen allow=\'autoplay\'></iframe></div>'
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.sizing === "responsive"
                      ? _c(
                          "textarea",
                          {
                            staticClass: "embed_url",
                            attrs: {
                              type: "text",
                              readonly: "readonly",
                              wrap: "off",
                              value: ""
                            }
                          },
                          [
                            _vm._v(
                              '<div class="flx-embed"><div style="position:relative; height:0; padding-bottom:' +
                                _vm._s(_vm.resizer.responsive.paddingBottom) +
                                '%; width:100%"><iframe style="position:absolute; top:0; left:0; width:100%; height:100%;" src="' +
                                _vm._s(_vm.flixel.embed_url) +
                                "?hd=" +
                                _vm._s(_vm.queryParams.useHd) +
                                '" frameborder="0" allowfullscreen allow=\'autoplay\'></iframe></div></div>'
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _c("p", [_vm._v("Copy this code to embed on your website")]),
                _c(
                  "a",
                  {
                    staticClass: "btn btn--blue",
                    on: {
                      click: function($event) {
                        _vm.copyToClipboard()
                      }
                    }
                  },
                  [_vm._v("Embed Code")]
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "embed__popup--item embed__popup--desc" }, [
      _c("p", [
        _vm._v(
          "Cinemagraphs are short videos. Most mobile and web browsers can only play a few videos on one page at the same time. If you embed more, please use caution and test"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61cc6bfa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61cc6bfa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmbedPopup.vue
// module id = null
// module chunks = 